function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useEffect, useMemo, useState } from 'react';
import {
  useReactTable,
  getCoreRowModel,

  flexRender,
  getExpandedRowModel,

  getSortedRowModel } from

'@tanstack/react-table';
import {

  KeyboardSensor,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
  DndContext,
  closestCenter } from
'@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { DraggableRow, RowDragHandleCell, DnDHeader } from "./DnDComponents";
import { IndeterminateCheckboxHeader, IndeterminateCheckboxRow } from "./RowSelectComponents";
import { dndSortHandler, getRowIds } from "./helpers";
import { SortingChevrons } from "./SortingChevrons";
import { GroupCell, GroupHeader } from "./GroupComponents";
import { NoDataRow } from "./NoDataRow";
import { DefaultNoDataMessage } from "./DefaultNoDataMessage";






























const Table = ({
  columns,
  data,
  onChange,
  dnd,
  enableSelections,
  defaultSorting,
  sortingFn,
  header,
  footer,
  className,
  noDataMessage = /*#__PURE__*/_jsx(DefaultNoDataMessage, {}),
  groupColumnPosition = 0
}) => {
  const [dataState, setDataState] = useState(data);
  const [rowSelection, setRowSelection] = useState({});
  const [sortingState, setSortingState] = useState(defaultSorting || []);
  const rowIds = useMemo(() => getRowIds(dataState), [dataState]);
  const { memoizedColumns, groupColumnIndex } = useMemo(



    () => {
      const tableColumns = [...columns];
      const hasGroups = data.find((item) => item.subRows);
      let calculatedIndex = 0;

      if (hasGroups) {
        const groupColumn = {
          id: 'group-button',
          cell: GroupCell,
          header: GroupHeader,
          meta: { headerClassName: 'w-0' }
        };
        tableColumns.splice(groupColumnPosition, 0, groupColumn);
      }
      if (enableSelections) {
        calculatedIndex += 1;
        tableColumns.unshift({
          id: 'select',
          header: IndeterminateCheckboxHeader,
          cell: IndeterminateCheckboxRow,
          meta: { headerClassName: 'w-0' }
        });
      }
      if (dnd !== null && dnd !== void 0 && dnd.enable) {
        calculatedIndex += 1;
        tableColumns.unshift({
          id: 'drag-handle',
          cell: RowDragHandleCell,
          header: DnDHeader,
          meta: { headerClassName: 'w-0' }
        });
      }
      return {
        memoizedColumns: tableColumns,
        groupColumnIndex: calculatedIndex
      };
    }, [columns, data, enableSelections, dnd]);

  const table = useReactTable(_objectSpread({
    data: dataState,
    columns: memoizedColumns,
    state: _objectSpread({
      sorting: sortingState },
    rowSelection && { rowSelection }),

    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
    manualSorting: Boolean(sortingFn),
    onSortingChange: setSortingState,
    getRowId: (row) => row.rowId,
    getSubRows: (row) => row.subRows || undefined },
  enableSelections && {
    //There seems to be a problem with react table types when using a function, typing as any fixes the issue
    enableRowSelection: (row) => row.original.disableRowSelection !== true,
    onRowSelectionChange: setRowSelection
  })
  );

  useEffect(() => {
    setDataState(data);
    setRowSelection({});
  }, [data]);

  useEffect(() => {
    if (onChange) {
      if (sortingState.length) {
        const sortedState = table.getSortedRowModel().rows.map((row) => row.original);
        onChange({ rows: sortedState, selectedRows: rowSelection, sortingState });
      } else {
        onChange({ rows: dataState, selectedRows: rowSelection, sortingState });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataState, rowSelection, sortingState]);

  useEffect(() => {
    if (sortingFn) {
      sortingFn(sortingState);
    }
  }, [sortingFn, sortingState]);

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active && over && active.id !== over.id) {
      setDataState(() => {
        let tableRows = dataState;
        if (sortingState.length) {
          table.resetSorting();
          tableRows = table.getSortedRowModel().rows.map((row) => row.original);
        }
        return dndSortHandler({
          currentState: tableRows,
          dataIds: rowIds,
          activeId: active.id,
          overId: over.id,
          disableEditingGroups: dnd === null || dnd === void 0 ? void 0 : dnd.disableEditingGroups
        });
      });
    }
  };

  const sensors = useSensors(
    useSensor(MouseSensor, {}),
    useSensor(TouchSensor, {}),
    useSensor(KeyboardSensor, {})
  );

  return (/*#__PURE__*/
    _jsx(DndContext, {
      collisionDetection: closestCenter,
      modifiers: [restrictToVerticalAxis],
      onDragEnd: handleDragEnd,
      sensors: sensors }, void 0, /*#__PURE__*/

    _jsx("div", { className: "w-full overflow-auto rounded-md shadow" }, void 0, /*#__PURE__*/
    _jsx("table", { className: `w-full ${className || ''}` }, void 0,
    header && /*#__PURE__*/_jsx("caption", { className: "p-4" }, void 0, header), /*#__PURE__*/
    _jsx("thead", { className: "bg-gray-50" }, void 0,
    table.getHeaderGroups().map((headerGroup) => /*#__PURE__*/
    _jsx("tr", {}, headerGroup.id,
    headerGroup.headers.map((hdr) => {var _hdr$column$columnDef;
      const headerSorting = hdr.column.getCanSort();
      const customClassName = (_hdr$column$columnDef = hdr.column.columnDef.meta) === null || _hdr$column$columnDef === void 0 ? void 0 : _hdr$column$columnDef.headerClassName;
      return (/*#__PURE__*/
        _jsx("th", {

          colSpan: hdr.colSpan,
          scope: "col",
          className: `p-4 text-sm text-gray-500 uppercase border-b ${customClassName || ''}`,
          onClick: headerSorting ? hdr.column.getToggleSortingHandler() : undefined }, hdr.id, /*#__PURE__*/

        _jsx("span", {
          className: `flex ${headerSorting ? 'gap-2 cursor-pointer select-none' : ''}` }, void 0,

        flexRender(hdr.column.columnDef.header, hdr.getContext()),
        headerSorting && /*#__PURE__*/_jsx(SortingChevrons, { sorting: hdr.column.getIsSorted() })
        )
        ));

    })
    )
    )
    ), /*#__PURE__*/
    _jsx("tbody", {}, void 0,
    dataState.length === 0 && /*#__PURE__*/
    _jsx(NoDataRow, { colSpan: memoizedColumns.length, DisplayElement: noDataMessage }),

    dataState.length > 0 && /*#__PURE__*/
    _jsx(SortableContext, { items: rowIds, strategy: verticalListSortingStrategy }, void 0,
    table.getRowModel().rows.map((row) => /*#__PURE__*/
    _jsx(DraggableRow, {

      row: row,
      colSpan: memoizedColumns.length,
      groupColumnIndex: groupColumnIndex,
      dndEnabled: !!(dnd !== null && dnd !== void 0 && dnd.enable) }, row.id
    )
    )
    )

    )
    ),
    footer && dataState.length > 0 && /*#__PURE__*/_jsx("div", { className: "p-4" }, void 0, footer)
    )
    ));

};

export { Table };